module.exports = __webpack_public_path__ + "static/media/DiamondBlur.3dcf548f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/DiamondBlur.svg
// module id = 156
// module chunks = 0